export default "__VITE_ASSET__BEkWlWxi__"